import React from 'react'
import BookingCancelationDetailsCard from '../../features/BookingCancelation/BookingCancelationDetailsCard'

const BookingCancelationDetails = () => {
    return (<BookingCancelationDetailsCard />)
}

export default BookingCancelationDetails